import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { parseISO } from 'date-fns';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { AcordoCliente, Contato, ParcelasCartao, TipoPlanoRenegociacaoCartao } from 'src/app/shared/models/customer-debt-renegociation';
import { AcaoRenegociacaoCartaoLoggerEnum } from 'src/app/shared/models/renegociacao-cartao-logger-service.model';
import { ServicoCartaoIndisponivelError } from 'src/app/shared/models/servico-cartao-indisponivel.error';
import { ToastService } from 'src/app/shared/toast';
import { RenegociacaoCartaoLoggerService } from '../renegociacao-cartao-logger.service';
import { RenegociacaoCartaoService } from '../renegociacao-cartao.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
  selector: 'app-acompanhar-acordo-page',
  templateUrl: './acompanhar-acordo-page.component.html',
  styleUrls: ['./acompanhar-acordo-page.component.scss']
})
export class AcompanharAcordoPageComponent implements OnInit {
  acordo: AcordoCliente;
  parcelasAcordo: ParcelasCartao[];
  debtId: string;
  contato: Contato;
  TipoPlanoRenegociacaoCartao = TipoPlanoRenegociacaoCartao;

  constructor(
    public breakpointObserver: BreakpointObserver,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private toast: ToastService,
    private renegociacaoCartaoService: RenegociacaoCartaoService,
    private renegociacaoCartaoLoggerService: RenegociacaoCartaoLoggerService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.googleAnalyticsService.pushPageViewEvent({
      page_name: '/renegocie/portal/servicos/cartao/acordo/emitir_boleto',
      page_template: 'renegocie'
    });

    this.route.params.subscribe(({ debtId }) => {
      if (debtId) {
        this.debtId = debtId;
        this.buscarAcordoVigente(debtId);
      } else {
        this.router.navigate(['../'], { relativeTo: this.route });
      }
    });
  }

  async buscarAcordoVigente(debtId: string) {
    try {
      this.loader.start();
      this.acordo = await this.renegociacaoCartaoService.buscarAcordoVigente(debtId, true);
      this.parcelasAcordo = this.acordo.parcelas
      this.contato = this.renegociacaoCartaoService.dadosRenegociacaoCartao?.contato;
    } catch (error) {
      if (error instanceof ServicoCartaoIndisponivelError) {
        this.toast.show({ type: 'error', title: 'Serviço indisponível.', text: 'Tente novamente mais tarde.' });
      } else {
        this.toast.show({ type: 'error', title: 'Erro ao buscar dados do acordo.', text: 'Tente novamente mais tarde.' });
      }
    } finally {
      this.loader.stop();
    }
  }

  // TODO: Ajustar os tipos referente as parcelas, está uma bagunça e precisar ser arrumado.
  handleEmitirBoleto(parcela: ParcelasCartao): void {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'emitir boleto',
      context: 'portal reneg:em dia'
    })

    this.renegociacaoCartaoService.parcelaSelecionada = parcela;
    this.renegociacaoCartaoService.salvarParcelaSelecionada(parcela);
    this.enviarLogEmitirBoleto(parcela);
    this.router.navigate([`portal/renegociacao/cartao/lista-cartoes/acordo/${this.debtId}/checkout/boleto`]);
  }

  mascararNumeroCartao(debtNumber: string) {
    if (!debtNumber) {
      return ''
    }

    return debtNumber
      .replace(/^0+/, '')
      .replace(/^(\d{4})\d{8}(\d{4})$/, '$1.xxxx.xxxx.$2');
  }

  enviarLogEmitirBoleto(parcela: ParcelasCartao): void {
    this.renegociacaoCartaoLoggerService.enviarLogRenegociacaoCartao({
      actionLogger: AcaoRenegociacaoCartaoLoggerEnum.CARTAO_BRADESCO_EMITIR_BOLETO_ACORDO_ACTION,
      cartao: this.acordo.idCartao,
      dividaId: this.acordo.idDividaBradesco,
      acordoId: this.acordo.idAcordo,
      nrParcela: parcela.nrParcela,
      vencimento: parseISO(parcela.dataVencParcela).toISOString(),
      valorParcela: parcela.valor,
      linhaDigitavel: parcela.linhaDigitavel,
    })
  }

}
